import React, { Component } from 'react'
// import { connect } from 'react-redux'

// import Icon from '../icon'

import { translation } from '../../../utils/helpers'

import '../elements.scss'
import './button.scss'

class Button extends Component {

  constructor (props) {
    super(props)
    this.state = {}

    this.onClick = this.onClick.bind(this)
  }

  onClick (e) {
    // console.log('Button onClick triggered!', e)
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getSolidClass () {
    switch (this.props.style) {
      case undefined:
      case null:
      case 'default':
      case 'cta':
      case 'primary':
        return ' solid-cta-base-700'
      case 'link':
      case 'secondary':
        return ' solid-link-base-700'
      case 'alert':
        return ' solid-alert-base-700'
      case 'active':
        return 'solid-brand-base-700'
    }
    return ''
  }

  getBorderClass () {
    if (this.props.noBorder) return ''
    switch (this.props.style) {
      case undefined:
      case null:
      case 'default':
      case 'cta':
      case 'primary':
        return ' border-1-pt-cta-base-700'
      case 'link':
      case 'secondary':
        return ' border-1-pt-link-700-base'
      case 'alert':
        return ' border-1-pt-alert-base-700'
      case 'active':
        return ' border-1-pt-brand-2-base-700'
    }
    return ''
  }

  getSpacingClass () {
    switch (this.props.spacing) {
      case undefined:
      case null:
      case 0:
      case '0':
        return ''
    }
    return ' pg-mb-' + this.props.spacing
  }

  getStyle () {
    let css = 'element-button' + this.getSizeClass() + this.getBorderClass() + this.getSpacingClass()

    if (this.props.round) {
      css += ' round'
    }

    if (this.props.dimmed) {
      css += ' dimmed'
    }
    switch (this.props.style) {
      case 'default':
      case 'cta':
      case 'primary':
        return css + ' cta'
      case 'link':
      case 'secondary':
        return css + ' link'
      case 'alert':
        return css + ' alert'
      case 'anchor':
        return css + ' anchor'
      case 'active':
        return css + ' active'
    }

    return css
  }

  render () {
    let ariaClass = ''
    if (this.props.ariaText !== null) {
      ariaClass = ' hint--' + this.props.ariaPos
    }
    let labelText = this.props.labelText
    if (typeof labelText === 'number') labelText = translation(labelText)

    return (
      <div className={'element-button' + ariaClass} aria-label={this.props.ariaText}>
        <button
          id={this.props.id}
          type={this.props.noSubmit ? 'button' : null}    // Apparently HTML <button> type default is 'submit' and not 'button' (!?)
          className={this.getStyle()}
          name={this.props.name}
          onClick={this.onClick.bind(this)}
          disabled={this.props.disabled}
          data-action={this.props.action}
          data-type={this.props.dataType}
          autoFocus={this.props.setFocus}
        >
          {this.props.leftChildren ? this.props.children : null}
          {this.props.labelText !== null && labelText}
          {!this.props.leftChildren ? this.props.children : null}
        </button>
      </div>
    )
  }

}

Button.defaultProps = {
  id: null,
  size: 'l',
  style: 'default',
  round: false,
  labelText: null,
  onClick: null,
  name: null,
  disabled: false,
  spacing: 1,
  action: null,
  dataType: null,
  ariaText: null,
  ariaPos: 'left',
  noSubmit: false,
  noBorder: false
}

// Button.contextTypes = {
//  router: React.PropTypes.object.isRequired
// }

// function mapStateToProps (state) {
//   return {
//     auth: state.auth
//   }
// }

// export default connect(mapStateToProps, {

// })(Button)

export default Button



// WEBPACK FOOTER //
// ./src/app/shared/elements/button/index.js